import { render, staticRenderFns } from "./integral-drawer.vue?vue&type=template&id=31864ed7&"
import script from "./integral-drawer.vue?vue&type=script&lang=js&"
export * from "./integral-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports